/* tslint:disable */
/* eslint-disable */
/**
 * Reckon Bolt API
 * Backend API for Reckon Bolt
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';

            export interface AppDownloadRetrieveRequest {
                version: string;
            }

        /**
        * 
        */
            export class AppApi extends runtime.BaseAPI {

            /**
            */
            async appDownloadRetrieveRaw(requestParameters: AppDownloadRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
                    if (requestParameters.version === null || requestParameters.version === undefined) {
                    throw new runtime.RequiredError('version','Required parameter requestParameters.version was null or undefined when calling appDownloadRetrieve.');
                    }

            const queryParameters: any = {};

            const headerParameters: runtime.HTTPHeaders = {};

                        if (this.configuration && this.configuration.apiKey) {
                        headerParameters["Authorization"] = <string>this.configuration.apiKey("Authorization"); // tokenAuth authentication
                        }

            const response = await this.request({
            path: `/App/download/{version}`.replace(`{${"version"}}`, encodeURIComponent(String(requestParameters.version))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
            }, initOverrides);

                    return new runtime.BlobApiResponse(response);
            }

            /**
            */
                async download(requestParameters: AppDownloadRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
                    const response = await this.appDownloadRetrieveRaw(requestParameters, initOverrides);
                    return await response.value();
                }

            /**
            */
            async appReleasesRetrieveRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
            const queryParameters: any = {};

            const headerParameters: runtime.HTTPHeaders = {};

                        if (this.configuration && this.configuration.apiKey) {
                        headerParameters["Authorization"] = <string>this.configuration.apiKey("Authorization"); // tokenAuth authentication
                        }

            const response = await this.request({
            path: `/App/releases`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
            }, initOverrides);

                return new runtime.VoidApiResponse(response);
            }

            /**
            */
                async releases(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
                    await this.appReleasesRetrieveRaw(initOverrides);
                }

        }
